module.exports = __webpack_public_path__ + "img/gb9118_8_h.prt.e209c569.jpg";